import { render } from "./MyRoomInfo.vue?vue&type=template&id=54d60a27&scoped=true"
import script from "@/assets/js/MyRoomInfo.js?vue&type=script&lang=js"
export * from "@/assets/js/MyRoomInfo.js?vue&type=script&lang=js"

import "./MyRoomInfo.vue?vue&type=style&index=0&id=54d60a27&scoped=true&lang=css"

import exportComponent from "/tmp/workdir/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d60a27"]])

export default __exports__